/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

// 工资条后台服务器地址
// export const baseUrl = 'http://192.168.31.34:8080'; //mwh
// export const baseUrl = 'http://192.168.133.103:8080'; //zj
// export const baseUrl = 'http://60.205.182.215:73'; // cs
export const baseUrl = 'https://gzt.renligongshe.com/server'; //正式


export default {
  baseUrl
}



// WEBPACK FOOTER //
// ./src/utils/global.js